import{d as e,e as o}from"../chunk-G6GIS7LZ.mjs";var r=new e({locale:"en",localeFallback:"en",locales:{en:o}});export{r as faker};
